import { render, staticRenderFns } from "./DirectMatchAcceptPopup.vue?vue&type=template&id=01f0b3fa"
import script from "./DirectMatchAcceptPopup.vue?vue&type=script&lang=js"
export * from "./DirectMatchAcceptPopup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports